
export default {
  data() {
    return {
      resultOnly: false,
      title: "Шкала векторного определения половой конституции мужчин",
      testDone: true,
      lenght: 0,
      items: [],
      colors: ["amber", "green", "blue", "lime", "yellow"],
      results: [
        {
          name: "Слабая половая конституция",
          value: 0,
          prc: 0,
          overall: 7,
        },
        {
          name: "Средняя половая конституция",
          value: 0,
          prc: 0,
          overall: 7,
        },
        {
          name: "Сильная половая конституция",
          value: 0,
          prc: 0,
          overall: 7,
        },
      ],
      questions: [
        "Возраст пробуждения либидо",
        "Возраст первого семяизвержения",
        "Трохантерный индекс",
        "Характер оволосения лобка",
        "Максимальный эксцесс",
        "Время достижения условного физиологического ритма (УФР)",
        "Абсолютный возраст достижения условного физиологического ритма (УФР)",
      ],
      options: [
        {
          description:
            "Вспомните, когда возникло влечение к противоположному полу, запишите эту цифру.",
          items: ["от 15 лет и старше", "от 12 до 14 лет", "до 11 лет"],
        },
        {
          description:
            "независимо от того, каким образом семяизвержение произошло — при половом акте, мастурбации, поллюции.",
          items: ["от 16 лет и старше", "от 13 до 15 лет", "до 12 лет"],
        },
        {
          description:
            "Чтобы его рассчитать, нужно измерить длину ноги от большого вертела бедренной кости (он легко прощупывается, если чуть-чуть покачать бедрами) до пола и рост. Трохантерный индекс равен отношению роста к длине ноги.",
          items: ["менее 1,91", "от 1,92 до 1,98", "более 1,99"],
        },
        {
          description:
            "горизонтальное (по женскому типу), с переходом на живот в виде дорожки волос к пупку (по мужскому типу), по мужскому типу с избыточным оволосением (гипертрихоз).",
          items: ["по женскому типу", "по мужскому типу", "гипертрихозы"],
        },
        {
          description:
            "Это максимальное количество семяизвержений за сутки (за 24 часа, а не за календарный день), за всю жизнь, независимо от того, каким образом семяизвержение произошло.",
          items: ["3 и менее", "от 4 до 6", "7 и более"],
        },
        {
          description:
            "Условным физиологическим ритмом считается 2-3 половых акта в неделю. Внимание! Не все женаты, и не все женатые достигли УФР. Эта графа может остаться незаполненной.",
          items: ["до 1 года", "от 2 до 10 лет", "более 10 лет"],
        },
        {
          description: "Эта графа может остаться незаполненной.",
          items: ["до 26 лет", "от 27 до 40 лет", "более 40 лет"],
        },
      ],
    };
  },
  computed: {
    breadcrumbs: function () {
      let items = [
        {
          text: "Консультации",
          disabled: false,
          href: "/",
        },
      ];

      items.push({
        text: "Психологические тесты",
        disabled: false,
        href: "/test/",
      });

      items.push({
        text: this.title,
        disabled: true,
        href: "/test/shkala-depressii-beke-bdi/",
      });

      return items;
    },
  },
  created() {
    this.questions.forEach((item, index) => {
      this.lenght++;
      this.items.push({
        name: item,
        description: this.options[index].description,
        id: index + 1,
        options: this.options[index].items,
        selected: -1,
      });
    });
  },
  mounted() {
    if (process.client && ym !== undefined && !this.$config.isDev) {
      ym("73133527", "hit", this.canonicalURL(), {
        title: this.title,
      });
    }
  },
  methods: {
    getResult: function () {
      let res = 0;
      let resIndex = 0;
      this.results.forEach((item, index) => {
        if (item.value > res) {
          res = item.value;
          resIndex = index;
        }
      });
      return this.results[resIndex];
    },
    updateResults: function (newResults) {
      this.results = newResults;
      this.resultOnly = true;
      this.testDone = true;
    },
    updateItems: function (newItems) {
      this.items = newItems;
      this.calculateResult();
    },
    calculateResult: function () {
      let selectedCount = 0;
      this.results.forEach((res, resID) => {
        this.results[resID].value = 0;
        this.items.forEach((item, itemID) => {
          if (this.items[itemID].selected == resID) {
            this.results[resID].value += 1;
          }
        });
        this.results[resID].prc = Math.ceil(
          (this.results[resID].value / this.results[resID].overall) * 100
        );
      });
      this.items.forEach((item) => {
        if (item.selected >= 0) {
          selectedCount++;
        }
      });
      this.testDone =
        selectedCount == this.items.length ||
        (selectedCount == this.items.length - 1 &&
          this.items[this.items.length - 1].selected == -1);
    },
    canonicalURL: function () {
      let res = "";
      if (this.$route.path[this.$route.path.length - 1] == "/") {
        res = this.$config.wwwURL + this.$route.path;
      } else {
        res = this.$config.wwwURL + this.$route.path + "/";
      }
      return res;
    },
  },
  head() {
    return {
      title: this.title,
      description:
        this.title +
        ". Тесты используемые психологом в работе. Результатами основной части тестов можно поделиться по ссылке.",
      meta: [
        {
          name: "description",
          content:
            this.title +
            ". Тесты используемые психологом в работе. Результатами основной части тестов можно поделиться по ссылке.",
        },
        { property: "og:title", content: this.title },
        { property: "og:url", content: this.canonicalURL() },
        {
          property: "og:site_name",
          content: "Психология для вас - Елена Елизарова",
        },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://www.elena-elizarova.ru/images/avatar.png",
        },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
